// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PlayArrow24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PlayArrow24Filled: FC<PlayArrow24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M8 19V5l11 7-11 7Z" />
        </svg>
    );
};

export default PlayArrow24Filled;
